import { EndPoints, post } from '../';
export function login(email, password) {
    var request = {
        email: email,
        password: password,
        environment: 'web',
        deviceId: navigator.userAgent,
    };
    return post(EndPoints.login, request);
}
